/* eslint-disable arrow-body-style */
/* global G */
import find from 'lib/sequence/component/children/find'
import seqRead from 'lib/sequence/model/api/read'
import sequenceComponentState from 'lib/sequence/component/state'
import { set } from 'lib/sequence/component/state/value'
import { isObj } from 'lib/util'
import { disable } from 'lib/sequence/component/state/disabled'
import enableButtons from 'app/typeExtension/event/enableButtons'

const {
  set: setConfiguration,
} = sequenceComponentState('configuration')

/**
 * If `value` is a stringified JSON object with a property with the same name as the current
 * session's language, returns its value; otherwise, returns the value of its first property.
 *
 * If `value` is not an object, returns it as is.
 *
 * @param {Gaia.AppModule.Spec} module  the current module composition object
 * @param {string} value
 */
const translatedValue = (module, value) => {
  if (isObj(value)) {
    const language = module[G.ADAPTER][G.SESSION][G.STATE][G.LANGUAGE]
    return value[language] || value[Object.keys(value)[0]]
  }

  return value
}

/**
 * Read Demo TypeExtension hook.
 *
 * Attempts to obtain a TypeExtension by its key, if it is set in the model state's ref namespace,
 * and map the view with its data. If there is no model state ref, it does nothing.
 *
 * @param {Gaia.AppModule.Spec} obj  the current module composition object
 * @returns {function(...[*]): Promise<*[]>}
 */
const readTypeExtensionDetail = obj => async (...args) => {
  const component = obj[G.STATE][G.ACTION][G.COMPONENT]
  const model = obj[G.MODEL]
  const ref = model[G.STATE][G.REF]

  if (ref) {
    const { label, dynamicDataConfiguration, dynamicData } = model[G.CHILDREN]
    const { label: viewLabel, dynamicData: dynamicForm, save } = find(component)

    await seqRead(model)(component)

    const labelValue = label[G.CACHE]
    const configuration = dynamicDataConfiguration[G.CACHE]
    const value = dynamicData[G.CACHE]
    const translatedLabelValue = translatedValue(obj, labelValue)

    set(viewLabel, translatedLabelValue || null)

    setConfiguration(dynamicForm, configuration)
    set(dynamicForm, value)

    await enableButtons(obj, component, value)
    disable(save)
  }

  return args
}

export default readTypeExtensionDetail
